import type { ModalProps as ADSModalProps } from '@qbe/ads-core';
import { Modal as ADSModal } from '@qbe/ads-core';
import * as React from 'react';
import { useEffect } from 'react';

import { useAppDispatch } from '~/hooks';
import { qalTrackEngagementAction } from '~/thunks/analytics';

export type ModalProps = {
  analyticsModalName?: string;
  responsiveHeight?: boolean;
} & ADSModalProps;

const Modal = ({ children, analyticsModalName, ...modalProps }: ModalProps) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (analyticsModalName && modalProps.open) {
      dispatch(
        qalTrackEngagementAction({
          eventAction: 'modal: open',
          eventLabel: analyticsModalName,
          data: {},
        })
      );
    }
  }, [analyticsModalName, dispatch, modalProps.open]);

  return <ADSModal {...modalProps}>{children}</ADSModal>;
};

export default Modal;
